import { render, staticRenderFns } from "./OfferBroker.vue?vue&type=template&id=ebd2b1ba&"
import script from "./OfferBroker.vue?vue&type=script&lang=js&"
export * from "./OfferBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports